<template>

  <div>

    <div class="bg-white">
      <br class="d-none d-lg-block">
    	<br>
    	<div class="container py-1">
    	  <br class="d-none d-md-block">
    	  <div class="row">
    	    <div class="col-md-6">
            <p class="small grey text-uppercase mb-2"><a href="/trailer-rental">{{`Trailer Rental in ${countriesStr('and')}`}}</a>:</p>
    	      <h1 class="h2">Curtain Trailer Rental</h1>
    	      <p class="lead grey">Rent a Curtain Trailer with <strong>PNO Rental</strong> for your next transportation need.</p>
    				<hr>
    				<p class="text-lg d-none d-sm-block">Find a Curtain Trailer that fit your transportation needs. Simply request your Curtain Trailer available for short-term rental with PNO Rental.</p>
    				<p><a href="/trailers?category=curtain" class="btn btn-lg btn-success">Search Curtain Trailers <i class="fa fa-chevron-right ml-1"></i></a></p>
    	    </div>
            <div class="col-md-6 col-xl-5 offset-xl-1">
                <img :src="require('@/assets/img/type_curtain.jpg')" class="img-fluid mb-3" alt="Curtain Trailer Rental">
            </div>
    	  </div>
    	</div>
    	<br class="d-none d-md-block">
    </div>

    <div class="container py-4">
    	<br class="d-none d-md-block">
    	<h2 class="h4">Curtain Trailer Features</h2>
    	<p class="lead grey">Curtainside trailers are the most common and flexible choice for transportation of industrial goods.</p>
    	<hr>
    	<br>
    	<div class="row">
    	  <div class="col-md-4">
    			<h5>Standard</h5>
    			<p class="grey">Specification for transportation when driving in Europe.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Huckepack</h5>
    			<p class="grey">For intermodal traffic.</p>
    			<br class="d-none d-md-block">
    	  </div>
    	  <div class="col-md-4">
    			<h5>Mega</h5>
    			<p class="grey">For extra high load in Europe, 3000 mm internal height.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Norway</h5>
    			<p class="grey">Specification when driving in winter conditions with heavy load and a 3-axle tractor.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Coil</h5>
    			<p class="grey">Specification for safe transport of paper and steel rolls.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Drop sides</h5>
    			<p class="grey">For extra load security.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>City</h5>
    			<p class="grey">City specification with lift for easy transport in urban environments.</p>
    	  </div>
    	</div>
        <hr>
    	<p class="small grey">The specifications listed are based upon PNO's most commonly rented trailers. They are not the exact measurements of all trailers rented by PNO. Specifications will vary by make, model and year of trailer.</p>
    </div>
  
  	<pno-how />

  	<pno-prompt />

  </div>

</template>

<script>
import PnoHow from '@/components/PnoHow.vue'
import PnoPrompt from '@/components/PnoPrompt.vue'
import { countriesStr } from '@/assets/countries';


export default {
	methods: {
		countriesStr
	},
    mounted() {
        this.$store.commit('meta/title', 'Curtain Trailer for Short-term Rental')
        this.$store.commit('meta/description', 'Rent a Curtain Trailer with PNO Rental for your next transportation need. Get your quote today!')
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/type_curtain.jpg') , 'ogimage'));
    },
	components: { PnoHow, PnoPrompt },
}
</script>
